
/**
 * Шапка нового дизайна: бургер, закрытие мобильного меню
 * и аккордеон подменю.
 *
 * Разметка — `header-new.php`, подключена на 33 шаблонах
 * (`get_header('new')`), поэтому модуль в общем бандле и своих
 * библиотек не грузит.
 */

export default function Header() {
    const header = document.querySelector('.header');
    const burger = document.querySelectorAll('.header__burger');
    const closeMobileBtn = document.querySelectorAll('.header__close');
    const headerInner = document.querySelector('.header__mobile-inner');
    const body = document.body;

    initSubMenu();

    header && burger.forEach(item => {
        item.addEventListener('click', () => {
            header.classList.toggle('header--active');
            item.classList.toggle('header__burger--active');

            if (header.classList.contains('header--active')) {
                body.style.overflow = 'hidden';
            } else {
                body.style.overflow = '';
            }
        });
    })

    header && closeMobileBtn.forEach(item => {
        item.addEventListener('click', () => {
            header.classList.remove('header--active');
            item.classList.remove('header__burger--active');

            body.style.overflow = '';
        });
    })

    header && headerInner.addEventListener('blur', (e) => {
        header.classList.remove('header--active');
    });
}

/**
 * Аккордеон подменю мобильного меню. Перенесён 1:1 из инлайна
 * `header-new.php:600` (Этап 6 §0).
 *
 * ⚠️ Слушатель висит на `<li class="header__mobile-link">`, а не на
 * вложенной ссылке: раскрытие управляется классом на самом `li`,
 * от него зависит `.header__mobile-sub-list` в `header-new.scss:322`.
 * Поэтому и клик по тексту ссылки, и клик по свободному месту пункта
 * дают один результат.
 *
 * ⚠️ Запуск сместился с момента парсинга разметки на
 * `DOMContentLoaded` (так вызывается `Header()`). Безопасно: функция
 * только навешивает слушатели, в DOM ничего не меняет и состояния
 * не читает.
 *
 * ⚠️ В HTML пунктов 6, в DOM 5 — шестой закрыт HTML-комментарием
 * в шаблоне. Код этого не касается, но сверку по количеству
 * это сбивает.
 */
function initSubMenu() {
    const subMenuTriggers = document.querySelectorAll('.header__mobile-link');

    if (subMenuTriggers.length) {
        subMenuTriggers.forEach((trigger) => {
            trigger.addEventListener('click', () => {
                trigger.classList.toggle('header__mobile-link--active');
            });
        });
    }
}
